import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import ElementUI from 'element-ui'
import '@/style/variables.scss'
import '@/style/leiStyle.scss'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

import '@/style/main.scss'

import pageCommonHeader from "@/components/page-common-header.vue";
Vue.component('pageCommonHeader', pageCommonHeader)

import defaultImg from "@/assets/image/default1.png"; // 无图片时默认图片
Vue.prototype.defaultImg = defaultImg

Vue.use(VueAxios, axios)
Vue.config.productionTip = false

import utils from '@/utils/utils.js'//全局变量
Vue.prototype.$utils = utils
import lazyList from '@/utils/lazyList.js'//省市区
Vue.prototype.$lazylist = lazyList.lazylist

//会员中心 手机端导航
import jquery from '@/utils/jquery.js'
Vue.prototype.$ = jquery
$('body').on('click', '.page-member .layout-container .side .title', function () {
  $('.page-member .layout-container .side .item').stop().toggleClass('show')
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
